import { Observable } from "./Observable.js";
export class AccumulatingObservable extends Observable {
    constructor() {
        super();
        this._accumulated = [];
        this.accumulatedObservable = new Observable();
        this.listenForAccumulated = (listener) => {
            this.accumulatedObservable.listen(listener);
            listener(this._accumulated);
        };
        this.stopListenForAccumulated = (listener) => {
            this.accumulatedObservable.stopListen(listener);
        };
        this.clear = () => {
            this._accumulated.length = 0;
        };
        this.listen((m) => {
            this._accumulated.push(m);
            this.accumulatedObservable.notifyAll(this.accumulated);
        });
    }
    get accumulated() {
        return this._accumulated;
    }
}
